import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { LazyService } from 'src/app/lazy.service';
import { BackgroundService } from 'src/app/services/background.service';

@Component({
  selector: 'app-background',
  templateUrl: './background.component.html',
  styleUrls: ['./background.component.scss']
})
export class BackgroundComponent implements OnInit {
  @ViewChild('dynamicBgComponents', { read: ViewContainerRef })
  container: ViewContainerRef;
  @Input() data;
  constructor(
    private lazy: LazyService,
    private background: BackgroundService
  ) {}

  ngOnInit() {
    this.lazy.loadAndRenderComponents(this.data, this.container);
  }

  setBackground() {
    return this.background.setBackground(this.data);
  }
}
